import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/home/Home.vue'
import HomeL from '../components/home/HomeL.vue'
import HomeF10 from '../components/home/HomeF10.vue'

// -----------------------  新资产管理 ----------------------
// 动态引入配置Bank_Id对应银行 40:连交运 30:青岛清算
const myWithdrawNew = (r) =>
  require.ensure([], () =>
    r(require(`@/modules/bank/bank${window.g.Bank_Id}${window.g?.Bank_Version ? window.g?.Bank_Version : ''}/bankrw`))
  )

const myBankInfo = (r) =>
  require.ensure([], () => r(require('@views/myAssetNew/tab/newBankInfo')))

const journalAccount = (r) =>
  require.ensure([], () => r(require('@views/myAssetNew/tab/journalAccount')))
const allFund = (r) =>
  require.ensure([], () => r(require('@views/myAssetNew/tab/allFund')))
const flowFund = (r) =>
  require.ensure([], () => r(require('@views/myAssetNew/tab/flowFund')))
const tranferNew = (r) =>
  require.ensure([], () => r(require('@views/myAssetNew/tab/tranferNew')))
// 未开户未签约
const noOpen = (r) =>
  require.ensure([], () => r(require('@views/myAssetNew/tab/noOpen')))
const noSign = (r) =>
  require.ensure([], () => r(require('@views/myAssetNew/tab/noSign')))
// ------------------------  新公告 --------------
const myNotice = (r) =>
  require.ensure([], () => r(require('@views/noticeMsg/myNotice')))

// 新个人中心
const UserCenterNew = (r) =>
  require.ensure([], () => r(require('@views/userCenterNew/UserCenterNew.vue')))
// 公告
const Notice = (r) =>
  require.ensure([], () => r(require('@views/notice/Notice')))
// const mail = r =>
// require.ensure([], () => r(require('@views/mail/mail')))
const NoticeList = (r) =>
  require.ensure([], () => r(require('@views/notice/tab/NoticeList')))
const NoticeDetail = (r) =>
  require.ensure([], () => r(require('@views/notice/tab/NoticeDetail')))

// 报表
const reportSystem = (r) =>
  require.ensure([], () => r(require('@views/reportSystem/reportSystem')))
const warehouseSys = (r) =>
  require.ensure([], () =>
    r(require('@views/warehouseReceiptSystem/warehouseSys'))
  )

// TODO 判断配置后动态引入交收系统
// 交收
const settlementSystem = (r) =>
  require.ensure([], () =>
    r(require('@/modules/settlementSystem/settlementSystem'))
  )

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
const routes = [
  {
    path: '/',
    name: 'HomeL',
    component: HomeL,
    redirect: '/login',
    children: [
      {
        path: '/register/:id',
        name: 'register',
        component: () => import('../views/reglogin/register/Register')
      },
      // {
      //   path: '/login',
      //   name: 'login',
      //   component: () => import('../views/reglogin/login/Login')
      // },
      {
        path: '/mail',
        name: 'mail',
        component: () => import('../views/mail/mail')
      },
      {
        path: '/personInfo',
        name: 'personInfo',
        component: () => import('../views/userCenterNew/tab/personInfo.vue')
      },
      // 公告
      {
        path: '/notice',
        name: 'notice',
        component: Notice,
        redirect: '/notice/noticelist',
        children: [
          {
            path: '/notice/noticelist',
            name: 'noticelist',
            component: NoticeList
          },
          {
            path: '/notice/noticedetail/:articleId',
            name: 'noticedetail',
            component: NoticeDetail
          }
        ]
      },
      // 公告列表 ---- 新
      {
        path: '/myNotice',
        name: 'myNotice',
        component: myNotice,
        redirect: '/myNotice/notice/noticelist',
        children: [
          {
            path: '/myNotice/notice/noticelist',
            name: 'noticelist',
            component: NoticeList
          }
        ]
      },
      // 报表系统
      {
        path: '/reportSystem',
        name: 'reportSystem',
        component: reportSystem
      },
      // 仓单系统
      {
        path: '/warehouseSys',
        name: 'warehouseSys',
        component: warehouseSys
      },
      // 未开户
      {
        path: '/noOpen',
        name: 'noOpen',
        component: noOpen
      },
      // 未签约
      {
        path: '/noSign',
        name: 'noSign',
        component: noSign
      },
      // 新资产管理
      {
        path: '/myAssetNew',
        name: 'myAssetNew',
        component: () => import('../views/myAssetNew/MyAsset'),
        redirect: '/myAssetNew/mywithdrawNew',
        meta: {
          requireAuth: true
        },
        children: [
          {
            path: '/myAssetNew/mywithdrawNew',
            name: 'myWithdrawNew',
            component: myWithdrawNew,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/myAssetNew/tranferNew',
            name: 'tranferNew',
            component: tranferNew,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/myAssetNew/flowFund',
            name: 'flowFund',
            component: flowFund,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/myAssetNew/myBankInfo',
            name: 'myBankInfo',
            component: myBankInfo,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/myAssetNew/allFund',
            name: 'allFund',
            component: allFund,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/myAssetNew/journalAccount',
            name: 'journalAccount',
            component: journalAccount,
            meta: {
              requireAuth: true
            }
          }
        ]
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import ('../views/testLogin/TestLogin.vue')
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/transcc',
    children: [
      {
        // 交易
        path: '/transcc',
        name: 'transcc',
        component: () => import('../views/transcc/transcc'),
        meta: {
          requireAuth: true
        }
      },
      {
        // 交易
        path: '/transccless',
        name: 'transccless',
        component: () => import('../views/transcc/transccless'),
        meta: {
          requireAuth: false
        }
      },
      {
        // 成交明细
        path: '/TransViewMore',
        name: 'TransViewMore',
        component: () => import('../views/transcc/TransViewMore'),
        meta: {
          requireAuth: false
        }
      },
      {
        path: '/quotationList',
        name: 'quotationList',
        component: () => import('../views/quotationList/quotationList'),
        meta: {
          requireAuth: true
        }
      },
      // {
      //   path: '/quotationListNosession',
      //   name: 'quotationListNosession',
      //   component: () =>
      //     import('../views/quotationList/quotationListNosession'),
      //   meta: {
      //     requireAuth: false
      //   }
      // },

      // {
      //   path: '/login',
      //   name: 'login',
      //   component: () =>
      //     import ('../views/reglogin/login/Login')
      // },
      // {
      //   path: '/register/:id',
      //   name: 'register',
      //   component: () =>
      //     import ('../views/reglogin/register/Register')
      // },
      // 交易相关
      // {
      //   path: '/transCC',
      //   name: 'transCC',
      //   component: () =>
      //     import ('../views/transCC/TransCC'),
      //   meta: {
      //     requireAuth: true
      //   }
      // },
      // {
      //   path: '/rate',
      //   name: 'rate', // transCC/rate/Rate
      //   component: () =>
      //     import ('../views/transcc/rate/Rate')
      // },
      // 新个人中心
      {
        path: '/UserCenterNew',
        name: 'UserCenterNew',
        component: UserCenterNew,
        meta: {
          requireAuth: true
        }
      },
      // 交收系统
      {
        path: '/settlementSystem',
        name: 'settlementSystem',
        component: settlementSystem
      }
    ]
  },
  {
    path: '/',
    name: 'HomeF',
    component: HomeF10,
    redirect: '/pageF10',
    children: [
      {
        path: '/pageF10',
        name: 'pageF10',
        component: () => import('../views/pageF10/index'),
        meta: {
          isIndex: true
        }
      }
    ]
  },
  {
    path: '/waiting',
    name: 'waiting',
    component: () => import('../views/waiting')
  },
  {
    path: '*',
    name: 'error',
    component: () => import('../views/404')
  }
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

export default router
